<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <!--                <base-input v-model="username" alternative-->
                <!--                            class="mb-3"-->
                <!--                            v-mask="'#######-#'"-->
                <!--                            placeholder="Número de inscrição"-->
                <!--                            addon-left-icon="ni ni-single-02">-->
                <!--                </base-input>-->
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '1234567-8',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX18tTttflMNIM1PDTaSlIqzoOaFHY/cCNlI=",
          "cpf": "U2FsdGVkX1+GzyGO+fuKgxJXjJ+x6bLq7+A8FRJvs0k="
        }, {
          "num_cand": "U2FsdGVkX1/u3AIb4/9HzY++W1nSo6qWPf8QPPehUT0=",
          "cpf": "U2FsdGVkX1/BPIKtD3et//EUXphr1KeNU/wrB8kllcE="
        }, {
          "num_cand": "U2FsdGVkX18X57xc/ivcqeFPbW/6T66cAlnaLy6G2Ac=",
          "cpf": "U2FsdGVkX19QtNYYJN5BkwYcCs4qGTipA8KYngFScZs="
        }, {
          "num_cand": "U2FsdGVkX19AxJNKz0qsRVY9u2Y9gi6dXNFo4lqVWCA=",
          "cpf": "U2FsdGVkX1+D0w/Rp3Mi24qTUCcLn9eLnrGfhvOS8Bc="
        }, {
          "num_cand": "U2FsdGVkX1/SICAxWWL+c8m9bjgmYO7QEPDsrYmWG7c=",
          "cpf": "U2FsdGVkX1+vftkd/9EdnLAWNJlSyhG/0nRHHo3/4w4="
        }, {
          "num_cand": "U2FsdGVkX181+9VIDymBhcVSxc12BAxthUHHUF1mneM=",
          "cpf": "U2FsdGVkX1+U4j4jNXsgIDcuMK1Hdp9dnw1J1TPOZlE="
        }, {
          "num_cand": "U2FsdGVkX1881cj+UGwS8pvt6AAmZ/RroOKGI1F5SlQ=",
          "cpf": "U2FsdGVkX1/7/fK6TO4CAD6z7zx+pC296+uscpdyQEM="
        }, {
          "num_cand": "U2FsdGVkX188zwJWGU7P2J13PW0dIX/wCk/IKXLqFAU=",
          "cpf": "U2FsdGVkX18pSS9taAYD5knFqNxAfeO5ERXdSUcHFwI="
        }, {
          "num_cand": "U2FsdGVkX19ywDb/Lw/qD8KqJZBS4NwFwgIQU1HsJG0=",
          "cpf": "U2FsdGVkX19trkiNt3TVO4YpiECaHKs9CozTABlXk+o="
        }, {
          "num_cand": "U2FsdGVkX18zoIkGcXIQfmDIKhskwqt80S3NtZz12eQ=",
          "cpf": "U2FsdGVkX1/CN9OvPhQmJEqnaRU3FTVyEcUabR2MqZ8="
        }, {
          "num_cand": "U2FsdGVkX1+yKD3m0M1dDusDcoJKTYKApgoNKHxTshw=",
          "cpf": "U2FsdGVkX19qvFgHTrzEybqJy5WZ2v4VNsdUUQT+PMk="
        }, {
          "num_cand": "U2FsdGVkX19M4sZBUAtEqj1MCoINFE4m1SCfNuw0qMg=",
          "cpf": "U2FsdGVkX1/MSKQ9aY+cS68BDQCmq1ksvjOHy5eYFEY="
        }, {
          "num_cand": "U2FsdGVkX18YmUotAd79rZkKr8G+dNJLcbVGsm1r6fE=",
          "cpf": "U2FsdGVkX1/I1Czv2vVwMzIQRu9nC2ZfM1mQQGKz8j4="
        }, {
          "num_cand": "U2FsdGVkX1/n8YQZHKQJYCc6Sj86PgO4TnymA3HJD9s=",
          "cpf": "U2FsdGVkX18sLWHu5fpobFTyUTVxdTX8mxrDAH/SS+Q="
        }, {
          "num_cand": "U2FsdGVkX1/ExtY5FBlHvhziWMaXGP1h1zqyT06l/4A=",
          "cpf": "U2FsdGVkX1+QpUTuwTmkRAZLj+TmR6EtppOlU46lsII="
        }, {
          "num_cand": "U2FsdGVkX1/ny5mxMykNuzCBMiErZCNu8IRSxXi5U28=",
          "cpf": "U2FsdGVkX19NFKkbGn5Ji6P5Ni7Pfy/bGO+Q2alzOh8="
        }, {
          "num_cand": "U2FsdGVkX19IdkLLa/gGMFV/LDK3iLltsc6s3UBUQsU=",
          "cpf": "U2FsdGVkX1/IsG9AyCvdC3MzjRYE6yd6iu4iPcv6Njc="
        }, {
          "num_cand": "U2FsdGVkX19U33RA6cc+Z7yQqd5hch2mt2io2T4rLko=",
          "cpf": "U2FsdGVkX18eTl3J2nUKN1vBb5+t/O8WyQLweNfkVds="
        }, {
          "num_cand": "U2FsdGVkX1+WESe95brHqgEqMBnUFqivJUSuu38opXc=",
          "cpf": "U2FsdGVkX184iye/dQn9q4eGU2q2w914dtkwl5XF4rs="
        }, {
          "num_cand": "U2FsdGVkX18xV2iYVWjXOoiS9WnUiJ7y+pV3Zr3GgP8=",
          "cpf": "U2FsdGVkX18YXlz+NjW4Cx2xwED0U9EfmjRschRuzNU="
        }, {
          "num_cand": "U2FsdGVkX19IfoBGyNoJ5nOgE2CcPuV7BJs2n2fEbFY=",
          "cpf": "U2FsdGVkX1+YXiI8blJjKaNLLUbCGiyL9b70vaKyD4g="
        }, {
          "num_cand": "U2FsdGVkX19Remwtc/wIA0D6s0lkcu7QmN8ARcIPwFw=",
          "cpf": "U2FsdGVkX19Pb8Oi4VZnDTyH8I5LD603gm+9BS5d06w="
        }, {
          "num_cand": "U2FsdGVkX181CNIhr2DXrb32ILT3j/KJ/r6UjxrSB/E=",
          "cpf": "U2FsdGVkX1+Og+4iXK6apIr/O5MWo/JWH+4OE+ooT9Q="
        }, {
          "num_cand": "U2FsdGVkX18uZHfQYuarRpTL/wJk7ZdINe32kE69z30=",
          "cpf": "U2FsdGVkX19+q2GFUCaOqdtZRHe4Vb287ZRqYipoF0c="
        }, {
          "num_cand": "U2FsdGVkX1/jLLgz9naglF9xOvB5Et/M+qOmhQzZzL8=",
          "cpf": "U2FsdGVkX19QAUZqMQOvd0OYSyq75wAqw+CarJtMO7o="
        }, {
          "num_cand": "U2FsdGVkX1+UkclR96lchw9gFljVgxfGOt42TX4m2uM=",
          "cpf": "U2FsdGVkX1+1bktaeo6D14fnSLyS9BtcA4CYLSZA1jA="
        }, {
          "num_cand": "U2FsdGVkX19cbbmk2Lmtwzea0cj2BF998ZCkk3pucII=",
          "cpf": "U2FsdGVkX1/aqcUQ70aKLCAdPT0EDrV/emKwRx/EDu0="
        }, {
          "num_cand": "U2FsdGVkX1/PWMA12vsootXOriabMMq4VwvY2HM7U+k=",
          "cpf": "U2FsdGVkX1/wrGp9m9F36evagBYmm2/8kDHklJPNlvY="
        }, {
          "num_cand": "U2FsdGVkX1/+8wSza5PmEAuEbnonCM78065mEbEE+pQ=",
          "cpf": "U2FsdGVkX1/IQ4fp+Nrxi+weJLpN2Mv2mWydamM6UhI="
        }, {
          "num_cand": "U2FsdGVkX1+TiPmTushba+xQA6m6wGyysC6fFJo9PD8=",
          "cpf": "U2FsdGVkX18tRoW+0x+3zUzmH4/6d2VIsrygaiEJvYc="
        }, {
          "num_cand": "U2FsdGVkX18+q6DSHWGbX74jGOYoGBtqEJni3jkD60Q=",
          "cpf": "U2FsdGVkX19PatE855aGDpXX8mDJx7jWabmZAnQ2uFE="
        }, {
          "num_cand": "U2FsdGVkX19OFreae9kE2rbsZ/7mpCb/t4Jky/u3oQw=",
          "cpf": "U2FsdGVkX18iejZV3BLlS4+o95DOeTCKYvSpFjviQ64="
        }, {
          "num_cand": "U2FsdGVkX1/JT//yK5IU4nO6axEXvFGn94snES8qHg8=",
          "cpf": "U2FsdGVkX1/6tmPauXLmQFLBPt2eU9L10aVlNoOSXQY="
        }, {
          "num_cand": "U2FsdGVkX18WPZgZuZMkZVmFrnXAAirTAk6UlNDaPg0=",
          "cpf": "U2FsdGVkX1/xpGnhYDg5sH92muyhKIJf6x0DJCrAo+M="
        }, {
          "num_cand": "U2FsdGVkX18EMD6yOHNrle6tYymy13Wxv09e/voHS+g=",
          "cpf": "U2FsdGVkX1+BdGVsKCXi+0CXcboL1VDTR1t6rSvBxes="
        }, {
          "num_cand": "U2FsdGVkX1+WQUNv/zFGThTtDBMPjVkDl3qe5dz00dM=",
          "cpf": "U2FsdGVkX1/8zOy0WehvF9VFg6elUnMl7y5Zdi6BPtA="
        }, {
          "num_cand": "U2FsdGVkX1/HZdWVdtoZdbhLnW0lDMZQuxWeQ9QnCzc=",
          "cpf": "U2FsdGVkX19eLg469tieMkCAVGkW6PEWBpIAz7ErZ9Y="
        }, {
          "num_cand": "U2FsdGVkX180jz+pgbpIwV9xKX48oGMq3NkW7OSsHe4=",
          "cpf": "U2FsdGVkX19AQfmk/F+eRoyp2Jm1rTaMLCoYcQgw0o0="
        }, {
          "num_cand": "U2FsdGVkX1/3UlE7ZCXBkOnznq0SqSzWRGtIiJVEXkc=",
          "cpf": "U2FsdGVkX1+l/tRle1yX4nMBc1sX1nd14nmIcYbbLLY="
        }, {
          "num_cand": "U2FsdGVkX18D6J39FAqm4RZp+5TK6eb14C446h3cIpE=",
          "cpf": "U2FsdGVkX1+Dej+Dq/rufA9+O3cAQmCD7Ce0XWnGwRM="
        }, {
          "num_cand": "U2FsdGVkX18F1g918PTcctwt7TpNeE15F3zjmtDp9f0=",
          "cpf": "U2FsdGVkX1+fin9y3AOFhX6D/2Y3OTtodLdFprcOvng="
        }, {
          "num_cand": "U2FsdGVkX191DBKEoc6uICxQivm6QIxhH61K3Q0fpyQ=",
          "cpf": "U2FsdGVkX19ma4pMcgEfV/ZX8OG/UoaAjg5Gzhj0cqA="
        }, {
          "num_cand": "U2FsdGVkX19ynCo0lEET8SDJItv3m7G02JGrhiy9QAc=",
          "cpf": "U2FsdGVkX19CtjajTxCvYcUUiNFIq6QjcSyGZvFfzNU="
        }, {
          "num_cand": "U2FsdGVkX1/AkUgpQ6js/HMdqCOEpsPqu6AQHxDuzQs=",
          "cpf": "U2FsdGVkX1+qnIhIF8NLkQsRCkahbOrvHhxPLQ+V8Gw="
        }, {
          "num_cand": "U2FsdGVkX184aS3E4J0UpV4sBKshwT8FsXQdCex8k+4=",
          "cpf": "U2FsdGVkX1/qZYdmfWwvEqd/KbKKJzzaV9Vf7lCXk3w="
        }, {
          "num_cand": "U2FsdGVkX1+gI/OPgYyIv+LCLjCLU2V4itK9QJsiGnY=",
          "cpf": "U2FsdGVkX1/WpLav9n3Q9N80RGFNdFMM1eiakamu/Dg="
        }, {
          "num_cand": "U2FsdGVkX18jiDeU9igXKKv63y9luOkpuslMfhGAV34=",
          "cpf": "U2FsdGVkX19W1jthXlS5Z78rhtpMLejLDjXesmxqCBQ="
        }, {
          "num_cand": "U2FsdGVkX1+5s+oGBMo3IJhBZAYN7BFbId2CSic89bY=",
          "cpf": "U2FsdGVkX1+elFV0QEooF0AygD1iW52lxQV09mAvJJg="
        }, {
          "num_cand": "U2FsdGVkX1/qW+ToPpubjfPfAgSxZk2IIsjUsjZCjbY=",
          "cpf": "U2FsdGVkX19UcMdFEsrtNoK3PS5UDjrYjQuDQOhdQVY="
        }, {
          "num_cand": "U2FsdGVkX1+Vix+Mv3mHVg+3SWOGnq1Ai8fNYutuvsc=",
          "cpf": "U2FsdGVkX1/13wxUW2t5p9V30vl5nH/wfawrrYd3wfM="
        }, {
          "num_cand": "U2FsdGVkX1+oU3TUUsao3NqZBZbgg6YIb2f5QLES1FI=",
          "cpf": "U2FsdGVkX18YHnnNwZHR+K+Vmp/jiupmphy2XciJqZ0="
        }, {
          "num_cand": "U2FsdGVkX19907AgDf5HLIO8pNFvl8e2Fvm6Af+jZ6o=",
          "cpf": "U2FsdGVkX19DI3GP4LYnzOkfc+4rgHNY3IH/Uwu7Lk4="
        }, {
          "num_cand": "U2FsdGVkX1+jCSPYLSMuZK0zot5i5yzRoNOrW0PDhWc=",
          "cpf": "U2FsdGVkX1/4ao3U0oLThix5whR8w2KD6L41l/g/hWU="
        }, {
          "num_cand": "U2FsdGVkX18XIwkeLxMjbYySNbaP60jjCQ1IGGaxI48=",
          "cpf": "U2FsdGVkX19TOIMdsytrXBN2Jm0Vc+I6RpGFupyU3+g="
        }, {
          "num_cand": "U2FsdGVkX1/wMnObpEYs3LmkihyGclkGpzzLkbpvoro=",
          "cpf": "U2FsdGVkX18KX9rX7Noo88Uy06ufkE2xXLekgIwWXYk="
        }, {
          "num_cand": "U2FsdGVkX1+O6xjE55LwZSL0eceQJxvVUyHXCQdBmn8=",
          "cpf": "U2FsdGVkX18koIAy/8+EcsVm4X/NetAUcu54fe2ZTNA="
        }, {
          "num_cand": "U2FsdGVkX19eZdxpldvddJlNsZ5Ez8mgdDnQYTZDZQs=",
          "cpf": "U2FsdGVkX1/K48e68JO6HRjPju0+1IqW73HCxk60g9g="
        }, {
          "num_cand": "U2FsdGVkX1/c9hU6okIfjI1zzQFhoMVMtwmhu5WQ+jA=",
          "cpf": "U2FsdGVkX19k0x3SESWem7+vLJPbhlHq/990s3k5+AQ="
        }, {
          "num_cand": "U2FsdGVkX1/9yd8UT1+i5j+lZRVTzRI+O8tDgQ8u0Lc=",
          "cpf": "U2FsdGVkX19fEgU2udDN6/46WQCV6ea9TvcnJpZmw0Q="
        }, {
          "num_cand": "U2FsdGVkX195s+jZfBdDYirIc0jVRyZzxorCyVNahq4=",
          "cpf": "U2FsdGVkX1+XAzfn3mF+IU3B4PPTuHWNN9Dw6FsAhSQ="
        }, {
          "num_cand": "U2FsdGVkX19iaDWcA4skJt1t5Fn9ZTYuVgJcF7c/6ow=",
          "cpf": "U2FsdGVkX1+lFSG8nVi6snUoFupkvHqNCvd/ZXxDNRk="
        }, {
          "num_cand": "U2FsdGVkX19yu6kr6FJLB6hdEo0IUOFNdTEd7V2Z/Ks=",
          "cpf": "U2FsdGVkX1+0BCadg9hAGzqi5bZqZ/79lfU8yOcpGJM="
        }, {
          "num_cand": "U2FsdGVkX1/pMH4ljrbZiAAnvbpYyiC86++ZBbI9THY=",
          "cpf": "U2FsdGVkX1+tDRE6miyegi6pu+mDi8CI7gA4pVq/Vj4="
        }, {
          "num_cand": "U2FsdGVkX1+djhrWoW5U5v/m+P7+yYWZCSY61fc/60w=",
          "cpf": "U2FsdGVkX18H50rPw2J3kLLHZO0Sr6E8s4Oop1zPCa8="
        }, {
          "num_cand": "U2FsdGVkX1+poMMJ9p4FMDzLw4Rmaf9lADRHvLLjIZI=",
          "cpf": "U2FsdGVkX18N+yqNhddmmyJoBNY7KnGYowyZGB8LXcM="
        }, {
          "num_cand": "U2FsdGVkX1/w6iD31eUzCGsSW43R9gg+TkOOnmJqfoo=",
          "cpf": "U2FsdGVkX1+/3KoIx4a52idLRChjlylgfCajx2r/XTY="
        }, {
          "num_cand": "U2FsdGVkX18uGma+auwbw00EzvtInwKqc2PSBTQ0drM=",
          "cpf": "U2FsdGVkX1+ONoKx9lucSU8oaykO0FsE6LGZhwdso/4="
        }, {
          "num_cand": "U2FsdGVkX19qK/AmmOu3FvVsXRUJGxT3vn3SppTNvlg=",
          "cpf": "U2FsdGVkX18+/UQlk8Cr2wTTLIZsuyxsUZ+O14sSoQ4="
        }, {
          "num_cand": "U2FsdGVkX196/aDIiVkgcjzzTQGNVrybCsyx9D7HNCU=",
          "cpf": "U2FsdGVkX189jiILmEeRfc4hxb0BYHSvSVvqEKJ8x50="
        }, {
          "num_cand": "U2FsdGVkX1+nKACfXfujwH8DdlWEQQp0+vZDa3oKyZw=",
          "cpf": "U2FsdGVkX182vDOFeirkWmRLEMG6ypQyygPuU+xowiM="
        }, {
          "num_cand": "U2FsdGVkX19IxawiyHTSJ3ndymSiWlKXOk5Pm6vV/qk=",
          "cpf": "U2FsdGVkX19Xx53vAK464wb0MzsgAQhDl7ZiZ5GUHMg="
        }, {
          "num_cand": "U2FsdGVkX1+pDVu5fZhw59IoDF+Ecezg7XRspnTE7y0=",
          "cpf": "U2FsdGVkX1/clTfjwUO+QSNe2gTznPL9bTikrYGs1M4="
        }, {
          "num_cand": "U2FsdGVkX18ZlCaDjvVP4SYqKMDwakMpr5XywJL9OiE=",
          "cpf": "U2FsdGVkX1/bP8ljOalNDU9yAUftsjKYTMglkuj7COM="
        }, {
          "num_cand": "U2FsdGVkX1/HTNSX+9lCdFYXWPyWa2v0IIWOL/A+EGE=",
          "cpf": "U2FsdGVkX19l0YBXjPIlyPmsYrL488711fEXKkyBbK4="
        }, {
          "num_cand": "U2FsdGVkX18KEFSoOY/7fjDjqX7vAEARCeqM1vjxWaE=",
          "cpf": "U2FsdGVkX19HEZMokIs3gj+9i7l6CPWeKNg6qPzfTRg="
        }, {
          "num_cand": "U2FsdGVkX1+JXn/uP+A+0QaF8VOsjIRTtliZ7DLLs18=",
          "cpf": "U2FsdGVkX1/AMKziDwVwMuUPG622VDYrhu6veJMe7/w="
        }, {
          "num_cand": "U2FsdGVkX19Qdpty4PAX8YElSnTum8Co01WGVuevTbQ=",
          "cpf": "U2FsdGVkX1/lqJa8xN7HUT0kzSm+rAlVVh+mDwvtR5Y="
        }, {
          "num_cand": "U2FsdGVkX19nb1c8iRLQWPVYiirvzPefq6PqldrGZRE=",
          "cpf": "U2FsdGVkX18HgnKwKYls0blw1Vq5/nTYz0pjLOKJtaE="
        }, {
          "num_cand": "U2FsdGVkX1/wcTUB0kS9Ws1jkgJ6/Jn3Aj7ykz+axiw=",
          "cpf": "U2FsdGVkX1/VjNrdcw8QWlmoVNvU5oqBsVxPFf/QGMw="
        }, {
          "num_cand": "U2FsdGVkX1/qINygMp9dpxJgCxbNxpO3rUDj7Y74JzE=",
          "cpf": "U2FsdGVkX1++LY3zCHwcf6b/uVd+g71uMqL+T5jWeXk="
        }, {
          "num_cand": "U2FsdGVkX1824wX7QQeDYRJ4/Sw5pPe10CqBlN6NoSc=",
          "cpf": "U2FsdGVkX1+ksVB8VLFrgMxCFiPVhvhe50hpMQleMp8="
        }, {
          "num_cand": "U2FsdGVkX18qRBvJFdSyawZ9m1ztmPJUC/4uuho6z6k=",
          "cpf": "U2FsdGVkX19Zecp+KNPsr9FBeJ9a6aq4KNv1XKFcSdc="
        }, {
          "num_cand": "U2FsdGVkX1+y2QuBhWq7HrYOhxiPkr9l1jkJXdGexUY=",
          "cpf": "U2FsdGVkX1+9YHKUx8xXeyGKkjEcsTaj8J30U3IRbM8="
        }, {
          "num_cand": "U2FsdGVkX19/kqFeNBGDGsN6jfMjkVE2kGe+fTe2Db0=",
          "cpf": "U2FsdGVkX1+Lzz0wvY6F10RzU3PvIMVPtp9pRLiU/P4="
        }, {
          "num_cand": "U2FsdGVkX1/U5pSZi0zKt6cdlXRTFNcpmGpKyQxhFds=",
          "cpf": "U2FsdGVkX1/DTs2jRJd/1SX4WShAXSkO+QDBfpB8cDg="
        }, {
          "num_cand": "U2FsdGVkX1+WQajV4GErWD2uKulLMxpowqIUyF6exdI=",
          "cpf": "U2FsdGVkX18o1H0YRO7HlMJKHJdgRq/cjJHYJfIR1dI="
        }, {
          "num_cand": "U2FsdGVkX19ljlIujOfJS5VzNJ0IquSAQ0tJZuiI0mU=",
          "cpf": "U2FsdGVkX1+G4JIvl5LmVxmm6WzkX9mYjlZSh0QiPf0="
        }, {
          "num_cand": "U2FsdGVkX1+0K7mjouqhWNFWtCGsSfqxzi+LwKV+VlY=",
          "cpf": "U2FsdGVkX1+oWQ/yQFnoeojR2aVyM+YKxoWHpWTgVaA="
        }, {
          "num_cand": "U2FsdGVkX1/Hsq9wfPF3MOcYoOwQT4kkn7hKemhDRDQ=",
          "cpf": "U2FsdGVkX19EiCqD8aPeQUvRYhVrK+tKdrv8Rnvi3bw="
        }, {
          "num_cand": "U2FsdGVkX18ZC87a1gU2OuTiPADt8ylCFAQEAzbXLG8=",
          "cpf": "U2FsdGVkX18Oyx0A5tF5QuAo1P7gKWbPmx50BQ9RWq4="
        }, {
          "num_cand": "U2FsdGVkX18jKXOmhj2pXTOPKlOBUaTYrGb8dpmPrBM=",
          "cpf": "U2FsdGVkX19mNWJfe2/TaIsGWib/YbGODu3UZdKrqD0="
        }, {
          "num_cand": "U2FsdGVkX1/I+r4dDsiHO7Bk812CA8Oc4lAq693ywgE=",
          "cpf": "U2FsdGVkX1+4yNtdLnUHDltjqbpbTAx90uTKndp9F7M="
        }, {
          "num_cand": "U2FsdGVkX19NdJ8yHknuA4NCsus3yY6VK9UddBrGiDw=",
          "cpf": "U2FsdGVkX18k00fF/1M1GS7YLUfMXhj6QidFzmPt4Eo="
        }, {
          "num_cand": "U2FsdGVkX19AoWp89bJvEDy79E/jYOLRCrdoxcOCyJY=",
          "cpf": "U2FsdGVkX193ZJhuydtAW/nqgviI9/wOvxNq/qhM/aY="
        }, {
          "num_cand": "U2FsdGVkX1822bTYvwvf2nwnJIShK30GRfiKBlEW2fU=",
          "cpf": "U2FsdGVkX18v+zXfvj56v8ffL1uU70gf7RXNJkjtkMg="
        }, {
          "num_cand": "U2FsdGVkX19FFWZZojU6IKT1ChTWhr/brxhpNNNH3hc=",
          "cpf": "U2FsdGVkX19VCH2N0coViJ9sipq5HjhEDhtD6tvuxIw="
        }, {
          "num_cand": "U2FsdGVkX1/RTDnBbWBc5UNU3J2pR7gcNDyOokzAiDY=",
          "cpf": "U2FsdGVkX18MU2ErAoBMc/kcPzT0l87o2incy9Y9acM="
        }, {
          "num_cand": "U2FsdGVkX18hfSWa02N2D90supb+r8HoTnqjlwdtP1k=",
          "cpf": "U2FsdGVkX18hLOZ4r9zohzrys0THo0mxE29JpFOQRGc="
        }, {
          "num_cand": "U2FsdGVkX1+tqqdQRJk/WrnUBfTgsBoeWgYUmTa1mB4=",
          "cpf": "U2FsdGVkX1+UqvbSTkNyTMpzvzh+xQUq64IkeqWDXyI="
        }, {
          "num_cand": "U2FsdGVkX192Es+ARQ5CVxYWAImB31I5yo2wv05ZtNg=",
          "cpf": "U2FsdGVkX1+qA0pSPe424SdB/pOSfoDMw39Tr30RTWg="
        }, {
          "num_cand": "U2FsdGVkX18cHuEHmyxDGtOTrUVfM1GYE8X8MxjwB00=",
          "cpf": "U2FsdGVkX19mv9xTYftQqlvlXuCALWVraSJglPQ6jto="
        }, {
          "num_cand": "U2FsdGVkX1/0C0SZlnUxMnHHjsuDFgEvlw3OVrfRz1E=",
          "cpf": "U2FsdGVkX19eone5V/AMBOn1aDUvH8OpJmdsSyjc2+s="
        }, {
          "num_cand": "U2FsdGVkX1+TyzVpsyLcavgDkO1moqgXtVJwpNbiBEk=",
          "cpf": "U2FsdGVkX1+W+lsT0YG9K6SbH3ULU+hL0S9MijHf0c4="
        }, {
          "num_cand": "U2FsdGVkX1+f+WkWWNEYSHgRii7D1EX+LG9sPTiGs/Q=",
          "cpf": "U2FsdGVkX19D1nHit1b1odA2ri7XVyej9jtAbbNxPUo="
        }, {
          "num_cand": "U2FsdGVkX19IHk/wKMymxNAqklP7Z2G5UIJENtdDDzM=",
          "cpf": "U2FsdGVkX19iM1YnKp5AZ50pEz9pkCEVYUUp2YlIrzY="
        }, {
          "num_cand": "U2FsdGVkX19phvTVatn2cjnNNIz5fMYY12nY2tvEYhU=",
          "cpf": "U2FsdGVkX19grpVe5VgzGGkjB9PiCiMVXvVqsjWyxz4="
        }, {
          "num_cand": "U2FsdGVkX1/c0YizW/cloaI4W5ZJXSofygxNQ6xc5IU=",
          "cpf": "U2FsdGVkX18SeUhcUIGff0CC5qsG8JpRrmwBDfrEPCw="
        }, {
          "num_cand": "U2FsdGVkX1/ADx2ksNgjAueJWQKNQkFdT5Kj8bv+C0k=",
          "cpf": "U2FsdGVkX192eZBIGHmefBe2rBTqMCOOchNhTtuI6BU="
        }, {
          "num_cand": "U2FsdGVkX19BJW0TkQ1jg6PZTd8bM8eSHFu6mB3EfFU=",
          "cpf": "U2FsdGVkX1+93XyBZGOufPdX8fSM6/sq14LZvorGOgw="
        }, {
          "num_cand": "U2FsdGVkX19XI/bE7G0ooz4xNWZyxLboXJQer0/wtK0=",
          "cpf": "U2FsdGVkX19ypL0lFtTsi1jLgbM4c/Z5swFmoelUb+Y="
        }, {
          "num_cand": "U2FsdGVkX18CkpAdxc+fCXdhnF96j2WUsNhKKZ0+DIo=",
          "cpf": "U2FsdGVkX19MkWtp1zN1DVzzm4Bode4DUFCpPi8YxlA="
        }, {
          "num_cand": "U2FsdGVkX1+A5e79hyA5naqV/SChUtv/gM11SMRHnys=",
          "cpf": "U2FsdGVkX18bjTWDZciI+HHHzEhe4zuxLEgoQB8F5rg="
        }, {
          "num_cand": "U2FsdGVkX1+/D4q+czZQ2Idxy4TasureP4pHJP3/i8Y=",
          "cpf": "U2FsdGVkX18bSREuFhW4W+mZf6nsaEcbmN5grzi/TrM="
        }, {
          "num_cand": "U2FsdGVkX1/HE5MTlv1yLTv4WN0+jFx5Yejl3LjrcTE=",
          "cpf": "U2FsdGVkX19GAm2vmvjwJSgDUG080NWTaAyEbf7EIWY="
        }, {
          "num_cand": "U2FsdGVkX1/E3ik6THjHuaLPBZoUjtDglwfEAGQuXcs=",
          "cpf": "U2FsdGVkX1+8GWul4WOrIRRNjHgnHdboSZuhbVcrtaE="
        }, {
          "num_cand": "U2FsdGVkX18OwsSj/p1ytFgtCQOxlPVDH/ga2wXVXCw=",
          "cpf": "U2FsdGVkX185eiWmsgXcaspFebi4/Gx+TTk8QUPKRTU="
        }, {
          "num_cand": "U2FsdGVkX19BVR2Sit5cDwxQcpIMfHQ/7Le41JTnUxA=",
          "cpf": "U2FsdGVkX18B5/RZgZ7K3bAaYwDSHj2iWAWjnVu9UeA="
        }, {
          "num_cand": "U2FsdGVkX1+vlMTElFvGws7hTE05J9xIvPMsn0K5Ygg=",
          "cpf": "U2FsdGVkX1/fivKJv4gnd4Id8FBvg2FQKHIaW6ej+4U="
        }, {
          "num_cand": "U2FsdGVkX1/n0/jkc7wuGJTYqov82/Cm4jlgRp5kWiU=",
          "cpf": "U2FsdGVkX18IbfNEEJS+1ROjio53ub2AkKhj2dnYaVQ="
        }, {
          "num_cand": "U2FsdGVkX1948ud8VjPvdOvp0MPbOMFQtv0zIW+5fu4=",
          "cpf": "U2FsdGVkX1+JBHPfuOoqZEV2eryv/Mqt7X2NfRlfhts="
        }, {
          "num_cand": "U2FsdGVkX19BkzhduUHVyPkkN80l5Tn4BbeokyeOIvI=",
          "cpf": "U2FsdGVkX1/RXM0S0foTPnH5Z/ZSQVGZstFydqSZsIo="
        }, {
          "num_cand": "U2FsdGVkX1/WLE8Iahk3Zads8ycSGEOPSvOmaWdTiBw=",
          "cpf": "U2FsdGVkX1+ScseLcM9EtQ+Z0aJwpv0rVSLhQsKvl3c="
        }, {
          "num_cand": "U2FsdGVkX181aRXuPdMzxIP/7WM0uMWRPy0lFwq0k+I=",
          "cpf": "U2FsdGVkX19ewcmoeh6yBHHAA/QrlfmUq22T7+qXZTw="
        }, {
          "num_cand": "U2FsdGVkX19x/8nEl/WYJSh0CDFFG5Ki8aDuWviEGtg=",
          "cpf": "U2FsdGVkX18Ni2athz2wyH04EzEm/KXNlB7tBObr0QA="
        }, {
          "num_cand": "U2FsdGVkX1+o9yXiZRasI8m2LOkaSrohozi5oE4e3Po=",
          "cpf": "U2FsdGVkX19lumgDCkFd6/N7xJPVd0vEJNXg8zVROAE="
        }, {
          "num_cand": "U2FsdGVkX19/DNBKOl2KuV9OHV21sSvNiSPRPq+zWI4=",
          "cpf": "U2FsdGVkX1+vYolxxvlvkJ9LtzlihDB9qbWnOGxkZEE="
        }, {
          "num_cand": "U2FsdGVkX19DRo1SaWpwZW0gu7bJqnVofpzwe55v9Ug=",
          "cpf": "U2FsdGVkX19/gYSsYVKNQ3Dpm3V6gsRXseghRNsGgck="
        }, {
          "num_cand": "U2FsdGVkX18lau37+JmUzxjYcLSMuzop0q1SLOTFo4Q=",
          "cpf": "U2FsdGVkX1/WVKpKx3WJH7C1jUvB24jwQID4oRf8S0I="
        }, {
          "num_cand": "U2FsdGVkX18QtAmVpNHNLfM8fuvoX+LozF1dbUI1UGU=",
          "cpf": "U2FsdGVkX1+0yNFzgYK6YEvtiJxN6SLruIc0dX0jea4="
        }, {
          "num_cand": "U2FsdGVkX1+LLoa4NVqouD9qkT3EkeUwaZyaWOMdxBk=",
          "cpf": "U2FsdGVkX188QE8IKnLtT/bmDCgQr8M7iQGZ8Ztl31o="
        }, {
          "num_cand": "U2FsdGVkX18sshdEGwmI34qL95iUQFFc5qFaRvmv0Hs=",
          "cpf": "U2FsdGVkX1/rbakPhOeGykKKcebfcuKk6b8r225qlC0="
        }, {
          "num_cand": "U2FsdGVkX19x2BHRQNELJuT8BMi+wNlslB4o+2obP7w=",
          "cpf": "U2FsdGVkX1/0KGO30wOoYUxZotLaSBH/dWGhYu8OEc8="
        }, {
          "num_cand": "U2FsdGVkX19XTRKIIBudar2VdjR+V6tV50xQ+d6H2uE=",
          "cpf": "U2FsdGVkX1/LUtVaDVEWL07RzrMkxg6pazzG422CyMU="
        }, {
          "num_cand": "U2FsdGVkX18NqU8QJVfUBWP9d3M+crCArB6BxtUdjPc=",
          "cpf": "U2FsdGVkX19LuO8KeFOfB/5wJWeARKRH46K0yFU7bds="
        }, {
          "num_cand": "U2FsdGVkX1/Td2Eo8zdA2KqI6AJAWET/+1fFHCOccmg=",
          "cpf": "U2FsdGVkX1+znmB/oRJbXC2F+lVJhzXRZCsmEOKdn5g="
        }, {
          "num_cand": "U2FsdGVkX1/TLbsmc+VCHyubJzuwIchBC/C5xkS7yus=",
          "cpf": "U2FsdGVkX19XQVGK2/lagin3O1J/T3lrj2wWIhxQAtE="
        }, {
          "num_cand": "U2FsdGVkX1/5Ft4S4mCl2PzYlXO+Cpanv/t9hYPBmwc=",
          "cpf": "U2FsdGVkX19O7dX0doesiFxdLQSB+1Nvd5lFrIoW3CI="
        }, {
          "num_cand": "U2FsdGVkX1+dW0Kug6mwhntYX+YS0BhTevjAeA24gYs=",
          "cpf": "U2FsdGVkX1/KaSMWBpLiFTvg5WKrV9Xyxmz0fSv+d9A="
        }, {
          "num_cand": "U2FsdGVkX1+4rs2QF0H5U5J5jg4oYiZix3IRId+A9vk=",
          "cpf": "U2FsdGVkX18z8WtBbiF0VNreOpZZbyvCFzA6Gj3bDdI="
        }, {
          "num_cand": "U2FsdGVkX19C3M5mGkhCnHtTmjQT6KyKOFxucB+7JL4=",
          "cpf": "U2FsdGVkX1/5geV0Aq/Sg0myr6T66V2LaVX0UzOAKqc="
        }, {
          "num_cand": "U2FsdGVkX1/w5dm4P9KDwkpz9LIxdX7EpS4DjRnGvUg=",
          "cpf": "U2FsdGVkX18x4f1QdHvf6UPu5bUvd5fKPpyc7jMJ1Mg="
        }, {
          "num_cand": "U2FsdGVkX19940MVV7CNy3pu72zSxhpPKZIjkCN0bjg=",
          "cpf": "U2FsdGVkX1/JfdonFB1eoDmPnL26JaRo3V1bTpmQED8="
        }, {
          "num_cand": "U2FsdGVkX1/HfiWECgu5sbl6qgRzpe+rlXd9ZEhv6hI=",
          "cpf": "U2FsdGVkX1/TxkVCmsXiNErXKsxRN5u6ZAsPdRo09kk="
        }, {
          "num_cand": "U2FsdGVkX1/jtV0bre27AWiGeY58cSeq9UNGXr2Y5s0=",
          "cpf": "U2FsdGVkX19t7JCWYHg3dPfCPHuQbgigv9UqnIT3O+Q="
        }, {
          "num_cand": "U2FsdGVkX19V6gpQhDZK/AhjorTumPeOVZRsUiWdtP8=",
          "cpf": "U2FsdGVkX18b5SPzjoPq9FWSA+HiFxtADbSdYVK+Qpg="
        }, {
          "num_cand": "U2FsdGVkX1+msCFRaKNKgQBZxgsDZiiS6Y4FVd/EBE8=",
          "cpf": "U2FsdGVkX1/JWuiBiAQFfQctTUAnMwCvBcKliIq8phc="
        }, {
          "num_cand": "U2FsdGVkX19MSObIQNMWebiUKSCM8fOYK3OlEkx3d80=",
          "cpf": "U2FsdGVkX1/N8zgi7ruWvZU2SDvkJUEsLS7Kx+eciKw="
        }, {
          "num_cand": "U2FsdGVkX1+FiuYdsKM0v1NE3hraah1yhS4IhrTkiK8=",
          "cpf": "U2FsdGVkX1+6WqZK3d3VxhLdV332mCr+E0P6RgJNl2s="
        }, {
          "num_cand": "U2FsdGVkX183XnrIzJflK0pPFON2dKfPootJp8Be0Lo=",
          "cpf": "U2FsdGVkX18wxX46v4BGpzdSTcu0k1Uf5HMkE2y3crE="
        }, {
          "num_cand": "U2FsdGVkX191CKksmjUIPcqKfiG+cM8LvHd0GOrSH84=",
          "cpf": "U2FsdGVkX18b9O6G+38Y4/lWmqRwJ9A6cGXp8MjOdbM="
        }, {
          "num_cand": "U2FsdGVkX1/WaIHOJg/oXhqmRrhTYiSwbosRz2ZM6jE=",
          "cpf": "U2FsdGVkX18JZgr+hLnhkO9NxNa7nnbf7sw97mR0/cw="
        }, {
          "num_cand": "U2FsdGVkX18tagVMOgLF/0Tulw8Jh1XB7+f7sz30mxg=",
          "cpf": "U2FsdGVkX19EEy/+4l8LkzkHl5PbjHxcaG9Vzf+QRRw="
        }, {
          "num_cand": "U2FsdGVkX18g26zbGv5p14MLTIk5Kv6ehnQ9dnhgyf8=",
          "cpf": "U2FsdGVkX18lNL/r+BDguZ6wjonV29sKQMPku8utNT0="
        }, {
          "num_cand": "U2FsdGVkX19GyP2mi6/bxA+x61u1PxxuhLTwv0XMQvg=",
          "cpf": "U2FsdGVkX1+RoSpwQBGC7Rep9i/EsUbGZWFWyF/d+fE="
        }, {
          "num_cand": "U2FsdGVkX19MzKNTYD30AMU3ucRUMp55gsUJglJPbQ0=",
          "cpf": "U2FsdGVkX1969Iuwr882LROs0WX8y1jwvkQXEv/nSoM="
        }, {
          "num_cand": "U2FsdGVkX1+Fa9hQR2LX4j/ZY79gWLX16u+Q/Wx3RZs=",
          "cpf": "U2FsdGVkX18BylxFODlPXeaVETz92eQFB/BdZF5e0J0="
        }, {
          "num_cand": "U2FsdGVkX1/e6l14rRlBAfhYd/xLnvCrLsmbJdaf2XE=",
          "cpf": "U2FsdGVkX182UGSTAevB+1I0y9QyHNQ/mVKEQGbyf8c="
        }, {
          "num_cand": "U2FsdGVkX19YFBQygajRAfEQHcklKL5oVqgMVg0E1Jw=",
          "cpf": "U2FsdGVkX194oHVX7cEbucK+8k4Cy5hZWzx/zwXSYJ8="
        }, {
          "num_cand": "U2FsdGVkX1/A1Kul0k/tJAJun52IVhZ5FhSOd9FUUsU=",
          "cpf": "U2FsdGVkX18qn9QORROqxpp/hXrXZ+sLuoizMwwylPA="
        }, {
          "num_cand": "U2FsdGVkX19XeWWlzhvRZLu0Ynf73uPLsVnAjxQOCi0=",
          "cpf": "U2FsdGVkX18+lsjpxBZFkAsgeCqoIjbrtB0t7sN7TWk="
        }, {
          "num_cand": "U2FsdGVkX1+wTMKkimh5vRa04hrnEJZLfRyzrDIyQ/Y=",
          "cpf": "U2FsdGVkX1/1okQSPgPlTWjE3m7n8944nClUn4G5YgQ="
        }, {
          "num_cand": "U2FsdGVkX19r3CUYh/ot9cbf5j/dstKoTbqCH8sG7oI=",
          "cpf": "U2FsdGVkX19mPCUNdmk1y12FN965rOHvxs9U21xOkN4="
        }, {
          "num_cand": "U2FsdGVkX19e5q/ju15P4WXSLGy4Jh1Hu+Timg4J4yk=",
          "cpf": "U2FsdGVkX19ZETq+royXV6I3n8Y8vkO3uqqJbr1nEjM="
        }, {
          "num_cand": "U2FsdGVkX18wjp9rA0tV4DMr+rBqnxm6UgC1/TgltkY=",
          "cpf": "U2FsdGVkX18VAOzpulZxNbbUE+1XWOKr3dLsfv+pYAE="
        }, {
          "num_cand": "U2FsdGVkX19oDFGjqwowpfUbry+BMQ/yaB220mhULgA=",
          "cpf": "U2FsdGVkX1+R1YCttxotxpM+0N2Ja3q8hkBlZLPquAg="
        }, {
          "num_cand": "U2FsdGVkX1+IDXz93phXIw74LpwCN6I3b39JMjIcP18=",
          "cpf": "U2FsdGVkX18s1SKJ5vjybTswNdecVRFB+1mEORtbM5I="
        }, {
          "num_cand": "U2FsdGVkX1/3wQyK9PZbUydQhK7r3zfBb6TzGdCsTV0=",
          "cpf": "U2FsdGVkX187yBGw8xdo2Yx0I53Ek98GXH2WTC8Xrw8="
        }, {
          "num_cand": "U2FsdGVkX19vRH6FGiNAjdcpXe1zY07u2FfGQI31ZPU=",
          "cpf": "U2FsdGVkX1/7Uq0iXe2FTLnT6oU1OHtSfXi6Iggsuww="
        }, {
          "num_cand": "U2FsdGVkX188JLDuiSSTZpK1uCveE2L3r/dWMDGxCcE=",
          "cpf": "U2FsdGVkX1//1orlc6TGdF0Qp8BA6wJh7vMnyTkDVP4="
        }, {
          "num_cand": "U2FsdGVkX1/1kNevZO4mmlFYu78b27/5h5QAklzMaNU=",
          "cpf": "U2FsdGVkX1+AUM9Zhq1U1fJmE7YjvAnIIwDXNGaJU3Y="
        }, {
          "num_cand": "U2FsdGVkX1/hvGNc+oF56Eef7ZDeSQR05cT/UQSiQ/U=",
          "cpf": "U2FsdGVkX1+4gC0U51dPkZuUxUHcX+cBGkhiUABIhww="
        }, {
          "num_cand": "U2FsdGVkX1+ZXa9hCUQtDgZqs7NMEnebMYsatj7rppE=",
          "cpf": "U2FsdGVkX1++kPG5o9XB70D777K/XaagEa6je+vHMEs="
        }, {
          "num_cand": "U2FsdGVkX19vSSix+ssVp3b5ux1Pw9abZm4c4zoD8o0=",
          "cpf": "U2FsdGVkX1+51fryFJ1/eVA1Bu9D7aBC1IjRfr/hR8g="
        }, {
          "num_cand": "U2FsdGVkX196kym8zkxh4ZXwEFzaHQhlvOm2YLQ0wos=",
          "cpf": "U2FsdGVkX183qNtN5+WejuVy7qp0Z6sxf0eetodKVOQ="
        }, {
          "num_cand": "U2FsdGVkX1/TR+j+xpzCHvn9nmpXfl2EvrcPKzt7WZE=",
          "cpf": "U2FsdGVkX1+Uip4N83Qg6jlGBNS6ax1d9SkYG/1stWk="
        }, {
          "num_cand": "U2FsdGVkX1+regTjNBauQYA0yTWmcXFK6CIyeMWXAHM=",
          "cpf": "U2FsdGVkX18/DP77G8ozNKC3w7vGp2m6fyGTDAiIgXA="
        }, {
          "num_cand": "U2FsdGVkX1+mdEIRFx/PVAlEiuWpNcYCpMGj1VrzhTY=",
          "cpf": "U2FsdGVkX18A7b9cVdtEo+OXsIPt5+fblEKi6RRJmyI="
        }, {
          "num_cand": "U2FsdGVkX19bcE6f0AdKKDWcNslMP9UYOxLeWQt3Vr4=",
          "cpf": "U2FsdGVkX1/umjzLsb5p09YGdy2w71nQLyVp4tHDALU="
        }, {
          "num_cand": "U2FsdGVkX18NYP+gUY3myU7wN5Ldy7qgLW920UWRtIQ=",
          "cpf": "U2FsdGVkX1+x7J6XxkUjMkvuRZCRB4WFrsFGWMvygdA="
        }, {
          "num_cand": "U2FsdGVkX1+yA7VFIY5Qd7+Rum30Qat3yWWvClYRhyg=",
          "cpf": "U2FsdGVkX19aOT2k7eYtAYKN2W7Jw2cvI/7jCf0VlNo="
        }, {
          "num_cand": "U2FsdGVkX1+ggAz7/DgP1fyBYU5xd25PutPDTed4A4A=",
          "cpf": "U2FsdGVkX19A1WwNM/A1Z6cZXJjIFWrhe77xePtNmU8="
        }, {
          "num_cand": "U2FsdGVkX1+klywSA/MihYA0tYQsmv5LdD/wnJgJY1s=",
          "cpf": "U2FsdGVkX18B7DJ9qcSeoBSWlQ9mT3ztkVZfDdO87WE="
        }, {
          "num_cand": "U2FsdGVkX19d8jSrmbXR5sGwMKKqXTGqLpRPTHjcBU4=",
          "cpf": "U2FsdGVkX19Fa7U796LEb9aZ4x+KoEL7zURK4R4494o="
        }, {
          "num_cand": "U2FsdGVkX19BIIR24Z7a0B+AGisqEkGufUfnn/xtlPQ=",
          "cpf": "U2FsdGVkX1/XVqzegeErn+l5k079bfd7DbXQg/VhSiw="
        }, {
          "num_cand": "U2FsdGVkX1/Gh7Wl5gQoxgTcmpi8CxbTByDgWPn33x4=",
          "cpf": "U2FsdGVkX1+MSlyG4VPTyOZxs1zXlixrfhxTQ9vmNe4="
        }, {
          "num_cand": "U2FsdGVkX184t/xzD/L6G+3XM+aAt7qs3pV7TvhAitg=",
          "cpf": "U2FsdGVkX194DM0t4V6Q8jgy0h6YdF8G6GRRsr+FWVI="
        }, {
          "num_cand": "U2FsdGVkX19hEcHbJdl/VqgqI7tYAGjsn/n8Qxi9IJQ=",
          "cpf": "U2FsdGVkX1/4ssVaDciGLadn7Sj3DFUPWlbJEf1faA4="
        }, {
          "num_cand": "U2FsdGVkX19dqnLkjNoxRSsWRHXVlnBc+dge17hLGqA=",
          "cpf": "U2FsdGVkX1+9IPLaXhHnSyZLDmsYunqabGNb4q33424="
        }, {
          "num_cand": "U2FsdGVkX18vkiM4sNM1rChpxUVGIMffY9lUNFBIPVA=",
          "cpf": "U2FsdGVkX1/SZMdDZvmiN9ik5p7xRj4bDSVsXDrifd0="
        }, {
          "num_cand": "U2FsdGVkX181AlSNOWc6UbgTXW+5Mpd2TomH5kbUQic=",
          "cpf": "U2FsdGVkX1+OXgXq9fxNcniBW2AZj8yXdf1H0tq+ieI="
        }, {
          "num_cand": "U2FsdGVkX18erRE+lIzUVCeODOgZ2bZY7HkNhQfBA9Y=",
          "cpf": "U2FsdGVkX19+Lk+2SvlUZnnZajxyt6RRFa+f08e6k1o="
        }, {
          "num_cand": "U2FsdGVkX199k8s2rN5Pv0Fq21bcIqxa3zwLq3G3Vn8=",
          "cpf": "U2FsdGVkX183Yw/b6EmyjE8XmmGN+xZiCGjKafCei/c="
        }, {
          "num_cand": "U2FsdGVkX1+zN3K6MdBM2nAacMZN9l7N3fdM6ZItFhQ=",
          "cpf": "U2FsdGVkX1+zbPiAoOutZQQ/c8u36USopksDBn/SLlA="
        }, {
          "num_cand": "U2FsdGVkX1+SyBq+RtPyIuQQDfOCJaIqVhk+JHJG2ps=",
          "cpf": "U2FsdGVkX18787e1MMxPrw8GpqUwxengIDHYdiSBh4A="
        }, {
          "num_cand": "U2FsdGVkX192xvrDemZvYvtn7Mh5JwORJtdH+HW0QvA=",
          "cpf": "U2FsdGVkX1+TOyHefUma2PwZ+JI7WOj9O0w7LPHOOtk="
        }, {
          "num_cand": "U2FsdGVkX19jqN5GbKU62DattUe9g+nKOGRLCrotiqc=",
          "cpf": "U2FsdGVkX18aCx4RkJdmj3/+jbgqByYqsq/q6cNd3DU="
        }, {
          "num_cand": "U2FsdGVkX1+zQc10RGFfOzsFdK1AWpsoHYlVI1YHNmo=",
          "cpf": "U2FsdGVkX18t5qFUL6IGOjrFGRcdu1M45+sMqqTnF4I="
        }, {
          "num_cand": "U2FsdGVkX1/0eW7vkwQsVkNpKhmuWDT0LuoQ22oeiyg=",
          "cpf": "U2FsdGVkX1/484uRaEHj5jdanJAQLq9wDFtf1gqjVCQ="
        }, {
          "num_cand": "U2FsdGVkX19Uu8yMmlCVSvOreL8eFFMu4HyXm9bkxuI=",
          "cpf": "U2FsdGVkX1+ugV0VDgrpss0ffi69dWy28oRn0gYY8lw="
        }, {
          "num_cand": "U2FsdGVkX19adhNf6LGO62eulSarG16yEiCtq7U175M=",
          "cpf": "U2FsdGVkX1/5rkHHpELqp6I+Ftd5UsEUocE6Z4BrOV8="
        }, {
          "num_cand": "U2FsdGVkX19w1j+2dquxNroT9FNm3vqSCyL+gnDwW6g=",
          "cpf": "U2FsdGVkX1/vzqUIsdARGdGMsmaJ5yYbQP9FPpvbgpA="
        }, {
          "num_cand": "U2FsdGVkX1/C+WjOZ1d8HL+F18Gb6KsZrwd5or9Iovs=",
          "cpf": "U2FsdGVkX18bEISRC99j9mbqJqzIuxd2/2BHclNmrvQ="
        }, {
          "num_cand": "U2FsdGVkX18owSxvuPu/ICjWuEJ9QD0wV+vKaKW9JP8=",
          "cpf": "U2FsdGVkX1/a9vMqUj3mmoyyvfhFtTLK+gGjCzO8mOg="
        }, {
          "num_cand": "U2FsdGVkX1/2rhnBXDo/TGSV8qzAY5f6ZOIcL7K+rfg=",
          "cpf": "U2FsdGVkX18ybh8JGE9Grn4V+X7T6zujo9Sn8GPI6Hw="
        }, {
          "num_cand": "U2FsdGVkX1+IRXjJvAQQnqH4vW91nusg5JqFHRFiXxQ=",
          "cpf": "U2FsdGVkX19qN7fYj0475G/Ajwjeg98OEn42TLuq6dk="
        }, {
          "num_cand": "U2FsdGVkX1+1cfnJktjb8hc9ptFJJ6++kVPrqirP+DI=",
          "cpf": "U2FsdGVkX1/zdG9awxqdsVPH9qGHD/Ned7/Cud9i9eg="
        }, {
          "num_cand": "U2FsdGVkX192aAYFtMQHztPnJHXiTmPbmqBQD85jAnY=",
          "cpf": "U2FsdGVkX19jDRhO8KN9ItVvTYuZxbLPrYiCZ9AqoNk="
        }, {
          "num_cand": "U2FsdGVkX19LCdEy6Ru1oM64Z7/K4hwjiKK20jf5kOQ=",
          "cpf": "U2FsdGVkX1+Y3cC6AJIaMyPYhn4maQxfe0FWppe6nBc="
        }, {
          "num_cand": "U2FsdGVkX19MzWgFrBt1iERLQY8U3E7JNqCpbvaglKU=",
          "cpf": "U2FsdGVkX1/f/wNDK2nKa2/ICrNXpYgg70tm7HRWOxw="
        }, {
          "num_cand": "U2FsdGVkX1/fEDueHwspWLPJ3+VF8ZTE9gqn6N8vN3U=",
          "cpf": "U2FsdGVkX1/kVuU9Wny1tyYJmL2SkXM0yqYJ2tKPJfY="
        }, {
          "num_cand": "U2FsdGVkX18yNBpMwTkjv16Caw6d+I7fnAGOrV4usn0=",
          "cpf": "U2FsdGVkX1/2yflHy6q0EUzYj4Efvi8tOXRXP7MTsdg="
        }, {
          "num_cand": "U2FsdGVkX1/z4/+gYMg/JzuRl9E88QEpto4qnmlOlVU=",
          "cpf": "U2FsdGVkX1/Wr4UtpAi1qIA5U8zBCLXJfh8ImYKVtMY="
        }, {
          "num_cand": "U2FsdGVkX1+N96Ar+fdiOC6bOq86lNOGjBPNhbHoWIU=",
          "cpf": "U2FsdGVkX1/pOiVFkobXzDfLbctRxIunvC0IKXsizNo="
        }, {
          "num_cand": "U2FsdGVkX1+Ic8sSloJRw0yGZiyZfejAcr4ay2ZegbE=",
          "cpf": "U2FsdGVkX1/oPx1sPGprYjRoqUFI9msDrXYDnsGzKHs="
        }, {
          "num_cand": "U2FsdGVkX19Q5UKl/RaZhl9eWIWSN9yN7TyGALh4rkA=",
          "cpf": "U2FsdGVkX19KmYlvJxyW4s8otBkKJgi2WekmtTROkMg="
        }, {
          "num_cand": "U2FsdGVkX1/O34RMf2A9uRyGQYoW9pBluK0NT2Z6XnQ=",
          "cpf": "U2FsdGVkX18p6OZu27Z2F3on0uu3JwRD38B3rUXKUII="
        }, {
          "num_cand": "U2FsdGVkX1+QA9394bZ1YwSHA2+LALqevc5dWSaBxJg=",
          "cpf": "U2FsdGVkX19606agvgQNvht932084AqNudb34cRHk2w="
        }, {
          "num_cand": "U2FsdGVkX1/yBwhlBix000uCeok5E2WiMEnrzr1hixY=",
          "cpf": "U2FsdGVkX1+S55pPAE0m8oWH+mDeI05VcbLDY0Af5/Q="
        }, {
          "num_cand": "U2FsdGVkX1/H+nRLWp4m/nwUITtu0TqfJuh7v7uKckk=",
          "cpf": "U2FsdGVkX19ygqI7PizY8ejQiQotHZccsHD8TegkTyU="
        }, {
          "num_cand": "U2FsdGVkX195JmYEAVUNhJap0Y0aDyqdukC/J2yP0OI=",
          "cpf": "U2FsdGVkX1/thpvNn2LqceIJRVwrOhgiD4mc1Tt6h+o="
        }, {
          "num_cand": "U2FsdGVkX1+3gQA4yMyz6ntGdzLg1IoF3XEUkR3wdxc=",
          "cpf": "U2FsdGVkX1/HdrbBphslbdD9kfzn5ucSnF/Xky5yU3o="
        }, {
          "num_cand": "U2FsdGVkX1+l9YxPCC2RNvyNSPzciaehLX5Gg8dKOc8=",
          "cpf": "U2FsdGVkX1+CQtkaqFfBlARpa2Z2lX6sUeFNdttVGWo="
        }, {
          "num_cand": "U2FsdGVkX1/No1rL3d7hhaDizZsoHJrsDwV4FEDz4B4=",
          "cpf": "U2FsdGVkX1/YaOYtdHjIN5GvnYMir6KlcsfIi+6t/E0="
        }, {
          "num_cand": "U2FsdGVkX1+E5pAoK9t/7a1Re20cvdw3lwTHUFIqToU=",
          "cpf": "U2FsdGVkX18ZYCCiqyVJYtbaXktk07+uGB8pFohns2g="
        }, {
          "num_cand": "U2FsdGVkX19e2YXugOfclvQWE1xUhe5De0GVY7W8A7o=",
          "cpf": "U2FsdGVkX19cXcBbCGJmbxRJaSmCwT8eg4eCNnJ3oyg="
        }, {
          "num_cand": "U2FsdGVkX1/dP6dGyrwpmQ+7TiII2D4fpcHgvjNwQOI=",
          "cpf": "U2FsdGVkX1+wpVbsEgQ0j7VdX//nzVFmrEW0YqTRYqA="
        }, {
          "num_cand": "U2FsdGVkX1+NkgYEXWQftiKAGsW/rA4p1GmzKxlE5nU=",
          "cpf": "U2FsdGVkX19/RZXB2UT1gIYjl8AiOoo+R6LkOJay1o0="
        }, {
          "num_cand": "U2FsdGVkX18yjQ65dKWT9ImDFtqqWR5Ar3ajdxwEVTI=",
          "cpf": "U2FsdGVkX1+GqN4OrKwfrrUUpvp98rIsU4DZiAMR7vw="
        }, {
          "num_cand": "U2FsdGVkX1897N0LOx409irj6PK59ezj6VIh0SOpVac=",
          "cpf": "U2FsdGVkX1/eGbSBfLAD2Cs+ahhXa9qlNfN238Mg1eg="
        }, {
          "num_cand": "U2FsdGVkX1+MDVa5XrIZQMvQDeWiIX0+NKf3q+Aw2ic=",
          "cpf": "U2FsdGVkX18kcv3pXeJkVhBcrhE2efrVjfxPwVugYl4="
        }, {
          "num_cand": "U2FsdGVkX18KTFdgs3Zw5TyAF1geDE069k0C8F6ZSos=",
          "cpf": "U2FsdGVkX19H8cop0iQfWEhoz4nW9Hk0pYQ9nunclc4="
        }, {
          "num_cand": "U2FsdGVkX1+OGpmXGD6O8PLqvI8PCIEVnD9dsabMyZ4=",
          "cpf": "U2FsdGVkX18tmOZVEXyCebNfekIkhmhKw32cAxKznX0="
        }, {
          "num_cand": "U2FsdGVkX1+hIaGCRJ5RJ/e+EsGSBLO7G5Sdz1ujS0U=",
          "cpf": "U2FsdGVkX1/9NTMTAd4FzKOSe5uFXC4aQs6rFH6WoCA="
        }, {
          "num_cand": "U2FsdGVkX1/ndxerzeDftL1ll1rpz5vOMzH8xiICo1A=",
          "cpf": "U2FsdGVkX18WsFHz06W4ofqEI/y0c/WAbwOhGIxNNhM="
        }, {
          "num_cand": "U2FsdGVkX18gMrGDq1k+V4R9Y/qffOk8SprWizZyiQU=",
          "cpf": "U2FsdGVkX1/kOmn4N5bjCOUlAN0p1EKs0UReLNEjxQw="
        }, {
          "num_cand": "U2FsdGVkX1+yU1B58Ryt/DtDf7MMvX11maVAN8+daYI=",
          "cpf": "U2FsdGVkX19nN6qzJBtlCkJqMpjEqvkkMwcks9L6rpo="
        }, {
          "num_cand": "U2FsdGVkX18d+LXIQ+icKWYBr4rFa69sRoxMXh0Naek=",
          "cpf": "U2FsdGVkX19bCGMwpApGwFbtj2JLR76gz4qcsg+VTjQ="
        }, {
          "num_cand": "U2FsdGVkX18BsYMl1jX+nOYHWnOsJYK+YJYRdxPHGeM=",
          "cpf": "U2FsdGVkX18Ghi+tbeapv2ta6ogVmxPr66dh19XxCc4="
        }, {
          "num_cand": "U2FsdGVkX1/QE3St7m8UdtY451jPTor8gaQKCeqFUsM=",
          "cpf": "U2FsdGVkX18UFJl8hMVmdvl+T9j46cYe636gXOhJjkk="
        }, {
          "num_cand": "U2FsdGVkX18TC/HScrm0IkPdCcM9oE3gsFYnoNaYErs=",
          "cpf": "U2FsdGVkX1/mSpQMaAF+cgdf7SLj8pEjY56GF4TKg1w="
        }, {
          "num_cand": "U2FsdGVkX1+uY983ZurmArwYp9WnfK+bHh/dLF8cpH4=",
          "cpf": "U2FsdGVkX19/1FGWVWMGGfRchI/EISxqk20lNail7hI="
        }, {
          "num_cand": "U2FsdGVkX182NWYRTKaMjO+4yEBFPVUfKDvwyPNR0Cg=",
          "cpf": "U2FsdGVkX1/3Urt4las6NmjPp3kbPWMQfrwmEjw4Y5c="
        }, {
          "num_cand": "U2FsdGVkX19//pV57G5Mqcpu+tKH4rI0I+2U4zrGugo=",
          "cpf": "U2FsdGVkX18hfwPHw9uCdOp11P8Fx0IFrwowrGLgdzI="
        }, {
          "num_cand": "U2FsdGVkX1+t6fV7Q46bSWZgfhfES5iCRA4g15lWXPY=",
          "cpf": "U2FsdGVkX18YQo1QDfGT0J4yboycMmo0adOgtTHqHI0="
        }, {
          "num_cand": "U2FsdGVkX1/Wkgpt7Q8FNHUNzLRyArYyEKoK7CrhkfU=",
          "cpf": "U2FsdGVkX18jsgwHPusxs2YmiSckLu68uDi9RsIbZQA="
        }, {
          "num_cand": "U2FsdGVkX1/5LNDoNhN8kwQ8V1V0ff8lZNp28Rp8sgY=",
          "cpf": "U2FsdGVkX1/M6Wrv5GSU0UdkDPnna6JN5s/0A3utEFE="
        }, {
          "num_cand": "U2FsdGVkX181tI8Xsp+gpHzSblTkX/dZo+7/5XV6vIg=",
          "cpf": "U2FsdGVkX1+AdLu9haWPvqbZRJE6rDYOp1uqF3fGArI="
        }, {
          "num_cand": "U2FsdGVkX1/J9TUwNQKNoWI+CQbjKIyuNPiIW/zj6gs=",
          "cpf": "U2FsdGVkX1/Wpw9A8OLMUXez1VihkkYWfZyoRkX0vqw="
        }, {
          "num_cand": "U2FsdGVkX1/VMj095GHykqOsC4z769XvEn7a+PaGKkY=",
          "cpf": "U2FsdGVkX19wx8OOWmbgQ2F3Ohlx0F59wdzVE93ZJSg="
        }, {
          "num_cand": "U2FsdGVkX18fBQIYNwagBlzAOSqRE8pQZtJwiSU4Bdo=",
          "cpf": "U2FsdGVkX1/W/J2aGT6tvNnYjo2R4V6bQw/SpzercIs="
        }, {
          "num_cand": "U2FsdGVkX1/ko83JOlh37Q149X+Mt2EGnz076e8oMyU=",
          "cpf": "U2FsdGVkX194b0CmFd8NBVFNUcWD9tKDZGwqJx8QUOs="
        }, {
          "num_cand": "U2FsdGVkX18fJdNf8NeuofeFv5QV3aYkiA9hTeNAkFE=",
          "cpf": "U2FsdGVkX19VSAp5bT/Nx8CZk1ylSCtyyrj0UyEjnsw="
        }, {
          "num_cand": "U2FsdGVkX19Rg+BjX4Naxj+o51gI6Z9l0j9zZAvSwn8=",
          "cpf": "U2FsdGVkX18U5XPKAgjaYF5K0hBi5euheEn1nRQfW9w="
        }, {
          "num_cand": "U2FsdGVkX1/Atr8bQXS7dISRFi1bi6FNkUf7yWtCxN0=",
          "cpf": "U2FsdGVkX19z5OBrpRnGYWkM8OoY9A3eaoTHxJhtXCY="
        }, {
          "num_cand": "U2FsdGVkX1+jFD8EPsW1hoZBAwZQm6pnM//j/B9P+ZM=",
          "cpf": "U2FsdGVkX183j0c48upZ+yQblpHWcI/W+d0BWEVPPkE="
        }, {
          "num_cand": "U2FsdGVkX1/jDNYt0XcdZDQSsV9WHJ6iGvM83AQg0kE=",
          "cpf": "U2FsdGVkX19mDmsQqcv1YK43O6w9hzq94NjmM41pMsE="
        }, {
          "num_cand": "U2FsdGVkX19TeAjLMO3hyHfNRduDfTfUN40Cdr44JJA=",
          "cpf": "U2FsdGVkX1+Amf0cAyAATL/WUSgzswwpamvHE2ZXhwE="
        }, {
          "num_cand": "U2FsdGVkX1+2hF/J3rYiUahFD46aNnGMUdyagnqWAAk=",
          "cpf": "U2FsdGVkX1+1fKMAOn6FuxzGnAHxE3/N4nqnaRwJ7n4="
        }, {
          "num_cand": "U2FsdGVkX189aIy1Ljl1XkAEIEHdp5Sza+bDXwuFmQs=",
          "cpf": "U2FsdGVkX19IgCzyyZf7zbZrBulSMxc67vQnkxhBySw="
        }, {
          "num_cand": "U2FsdGVkX1+mdd88oRt0amKix+cjct3lk54Gqrr09ug=",
          "cpf": "U2FsdGVkX1+lkLoPcKIOGt0fHAFoBbJInmD/5tO4E7I="
        }, {
          "num_cand": "U2FsdGVkX19KUt+B2Edm3Ft2A8JriMz8nRnCCn7tHX0=",
          "cpf": "U2FsdGVkX18wzt1ZLuGnWyiaSPCKo+BJSYEv0FVlqaQ="
        }, {
          "num_cand": "U2FsdGVkX1/7mT0PmdFsAD6riaMQTtP+CLoP7SinLM4=",
          "cpf": "U2FsdGVkX18niWLjmhTrZ7U1Lo9QEtNwvRaGJQpwbjQ="
        }, {
          "num_cand": "U2FsdGVkX19hpE+Nss4tpLQRWAcebGnhxRAq44fM0HI=",
          "cpf": "U2FsdGVkX1+pNTQeNvZhAf7Co8uvEA3Iipb9VotBjR8="
        }, {
          "num_cand": "U2FsdGVkX1+4pw4A9kqTEtmNm9lo8UVZcbULwdENYt0=",
          "cpf": "U2FsdGVkX1+OAC7vpMg62MXLFxhMR/bR6ic/TwtRRtU="
        }, {
          "num_cand": "U2FsdGVkX1/irmNWCkACdSHzI3+w1dk04wyhHZ0oP7Q=",
          "cpf": "U2FsdGVkX1/mR8fiEXljWCFFpU4x0i27d2ouK8is44E="
        }, {
          "num_cand": "U2FsdGVkX19sFTVCgrWIaUDjut55zSvXzw9XkA7ehg0=",
          "cpf": "U2FsdGVkX1/iaFD+Oiz1s7ZfGJn4ZX3hEBeRWYppYe8="
        }, {
          "num_cand": "U2FsdGVkX1/kgPB519n4wHonf87uvFHaYBBh7codxwY=",
          "cpf": "U2FsdGVkX18bppGW0rqGbMWFdu2NKfVsqr0y6+OE2aE="
        }, {
          "num_cand": "U2FsdGVkX1/HBC5C/WIDOibqKOqF1RONPan1P4dBJSQ=",
          "cpf": "U2FsdGVkX192QTeIhaRiHeUOGVXXu74lqhK0Gyr7Yf8="
        }, {
          "num_cand": "U2FsdGVkX1/JOFimpHxTuAlFEC/QPpdAJAMOC+Vf6Gc=",
          "cpf": "U2FsdGVkX19Kz7Z7dhU8cmDXT62AeEa26SY1rFjW6Ag="
        }, {
          "num_cand": "U2FsdGVkX1+2KyOeHF5+GqaQTzzWkB2jiOT732jdRSY=",
          "cpf": "U2FsdGVkX19Hjj7CPnFlta2D29bCDyvolzPZwsHP/n4="
        }, {
          "num_cand": "U2FsdGVkX18OMXVSKwPQE4SAMCQO7FXDCUvnI76o4F4=",
          "cpf": "U2FsdGVkX1+AaD3pUyATNaA3kyLBZ7G3sn3mw8d1R4Q="
        }, {
          "num_cand": "U2FsdGVkX18OUKV/EFWBdvNRszdgtomQQ+bPhL4c+s8=",
          "cpf": "U2FsdGVkX1947EjI0OrIji4baiXZhE0PMEu0vcOdoBo="
        }, {
          "num_cand": "U2FsdGVkX1+nt44LQ76Evyswi0H5nFlx8chAAtFl8xQ=",
          "cpf": "U2FsdGVkX1+Bp44yZ71FnEyzgSQT2wlySZ47u96X01s="
        }, {
          "num_cand": "U2FsdGVkX18NKRUOMtAnHpAxHMN7zE9WnblxBPsw9h8=",
          "cpf": "U2FsdGVkX18Y6FIfdkbdVCxbj7+ybBn43K8UBHi5J1k="
        }, {
          "num_cand": "U2FsdGVkX18tY1ZlqUD5J94OS/eGOek/saG4by4vhCE=",
          "cpf": "U2FsdGVkX18kDypJm8tEQUWsLk+jzxTCAhH4uBuExOo="
        }, {
          "num_cand": "U2FsdGVkX1+49zM6BLjy2nrWURZifE6oZ5alS+ZnaLI=",
          "cpf": "U2FsdGVkX198odSwHbaSOsbZFbW7MCWthszqaeQeHc4="
        }, {
          "num_cand": "U2FsdGVkX19SJJ3fIK/jSABEVEhcSh5026vombOaRlc=",
          "cpf": "U2FsdGVkX199ihLh0+C9186j66gvtYDuKeZx/AFwIQc="
        }, {
          "num_cand": "U2FsdGVkX182M8ndyIDIrROSXGoURKKPUUyCkKK3kL8=",
          "cpf": "U2FsdGVkX1/YK/MOhqNbz8LsmB5ZTogPfgPOxdNY3hk="
        }, {
          "num_cand": "U2FsdGVkX19gfQMPGO/2OgoTH5WKseR7tzaZDxfeX2I=",
          "cpf": "U2FsdGVkX1/cbGOMCVQ8vjKu3a+fHJQ21yCn8jHu9W8="
        }, {
          "num_cand": "U2FsdGVkX19/eWSPVOo9F8YIvmxssYiIBeL9I/V1BOI=",
          "cpf": "U2FsdGVkX1/ARBf+Ol5FFAoQIBzANGqyqUBaTg4MbmM="
        }, {
          "num_cand": "U2FsdGVkX1+av/XRoKW6ch/dU+BwVCgj7EfKAS7aRNY=",
          "cpf": "U2FsdGVkX1+Ktv+XH92/DzP09kEno7rcjXPozP6NMoI="
        }, {
          "num_cand": "U2FsdGVkX19eGZ6mGiCyGyaT2bBIYwb2IFbzQrklXQE=",
          "cpf": "U2FsdGVkX19p627E+97dGj/Pm/wmUKkqb54nlvKg0/U="
        }, {
          "num_cand": "U2FsdGVkX1893upKCkyH1HsD7pCsUan8a0CHQP9qN5s=",
          "cpf": "U2FsdGVkX19q1Fk6nKLyrwlyL4xFZ8tiFfzI+nmny/s="
        }, {
          "num_cand": "U2FsdGVkX19L2A9UsOakNHf4vyY49UeIXBmwaGR7l7k=",
          "cpf": "U2FsdGVkX1/RJfZBu+7uG7+RgmCmqglW853z6FixfXc="
        }, {
          "num_cand": "U2FsdGVkX1+IbX6fv2/475R+S6h8q9BI3DN1l1mF+sY=",
          "cpf": "U2FsdGVkX1/9PXLd/0BNXpO6zefehvoeL50Oq34kf+c="
        }, {
          "num_cand": "U2FsdGVkX1/Zi9ijtAgZSdc4rlOVpozS5FvKe+Y2ABI=",
          "cpf": "U2FsdGVkX19umpg2hTz8BI9PWUWsSapGXP2w5rIzlPc="
        }, {
          "num_cand": "U2FsdGVkX1/AtGLw4USmCF6fpd5xQ4vcoDhHe6xy45k=",
          "cpf": "U2FsdGVkX18i01zA4LBw7RjPHb6whjga4VWazBjfK/A="
        }, {
          "num_cand": "U2FsdGVkX19Ndb3kl8b6j95foG8PZwWpRKmO/Y6NFy4=",
          "cpf": "U2FsdGVkX18Nv1CUAxvSPtTqPRTUMt52Cor2NGczNp0="
        }, {
          "num_cand": "U2FsdGVkX184nwlNxssvwGHdFZfZLWTTB14xuwQZ3Ak=",
          "cpf": "U2FsdGVkX18VsQ6hjsp0i023LpxCNt8NL8MQVFF4sCs="
        }, {
          "num_cand": "U2FsdGVkX19AL5WIo2Ri0hmibjGZsu3dNDlAxJCT6OU=",
          "cpf": "U2FsdGVkX18Q2OgGkBZjPxrmniLnOokVuDZRJB4+tdU="
        }, {
          "num_cand": "U2FsdGVkX19cuM3SdDBiJ/NClRUg5kAMCBpnCgg0zIM=",
          "cpf": "U2FsdGVkX19eOHHdlUV2g4DPXhYGTziB1x9h/nmJxD8="
        }, {
          "num_cand": "U2FsdGVkX19D4+5Jvz9Zefu/9hPFDaMCM2/0a2kDe2I=",
          "cpf": "U2FsdGVkX18kaC5f9JRRjYjyzZ8JBTQijsemfJYyAYc="
        }, {
          "num_cand": "U2FsdGVkX1+4zDTABCqWkKL4HXrfCG2W9wlnc9hY5J8=",
          "cpf": "U2FsdGVkX19rFJXX4QrW7bcSpAMDgjFPQc1JBb+ELSs="
        }, {
          "num_cand": "U2FsdGVkX19pf6Zd+zjEDoCAeV8I8UvSRVTCxA7z8E0=",
          "cpf": "U2FsdGVkX1+adsRtSmAGjbGkUwmz+tisL54ANMjtVRo="
        }, {
          "num_cand": "U2FsdGVkX1+LQRNbdhQqxKEUsAUDiCd1b6azkSrOzu0=",
          "cpf": "U2FsdGVkX18AzgB6Yy1MK3q7XdXy3sUFYV9CLmtdvsw="
        }, {
          "num_cand": "U2FsdGVkX1/ICXoouePPOMLy7NOUgzT/1Wl8XNzNOKs=",
          "cpf": "U2FsdGVkX19M2rE9A4qcxuesOSy2B6+04iY40LBTqk4="
        }, {
          "num_cand": "U2FsdGVkX1+AGkytYsg+2GTlSJtgaRgVGWaop4wp3JE=",
          "cpf": "U2FsdGVkX19d18JKJdKFsAPvibTOpC2BZ5ANcIiPYqI="
        }, {
          "num_cand": "U2FsdGVkX1/5R/ehdXiZeUdXQ0Evcknl1p0IWc8e34w=",
          "cpf": "U2FsdGVkX1+/dAmo32fv9SWTBcLUUIWM3lUqvpliVms="
        }, {
          "num_cand": "U2FsdGVkX1926XJbu6YyZsnnir/UdJJe8/gJoqzVmD8=",
          "cpf": "U2FsdGVkX1+634VfdKqWha6rF6FaN0MsmrkvQH6ZbSQ="
        }, {
          "num_cand": "U2FsdGVkX1+rMpq+xvTKkMz2G2mFHEY4EMBe1DlRJY8=",
          "cpf": "U2FsdGVkX1+rOCpHmraa/eQLtuwnAbY+0s3XXO85m2I="
        }, {
          "num_cand": "U2FsdGVkX1+xS6WNJyChszZabgeX9IgOeeFNnuq0aOQ=",
          "cpf": "U2FsdGVkX1/Y1+8yqQCgiKTXtIRc79LZjXiXWwuFmms="
        }, {
          "num_cand": "U2FsdGVkX1+cE0xDC+TcN8N5EHml3jNM8GuxFdUUQV4=",
          "cpf": "U2FsdGVkX1/itkzt1d1lBKqhAz8R12kEnRG6lJEbNMo="
        }, {
          "num_cand": "U2FsdGVkX1+r4+Jmn8ynwglX08a/nS27W8TETyaBR0c=",
          "cpf": "U2FsdGVkX185PtW1rorEmWFOphIRKSMhliSydTddtRQ="
        }, {
          "num_cand": "U2FsdGVkX190jzldsyXUcdSRlbYNrIb2f7YEhy+fsxY=",
          "cpf": "U2FsdGVkX18lPkhTCjI+AwDmpipRas59AcjXHnifVgk="
        }, {
          "num_cand": "U2FsdGVkX18DPVfV4ywT4AQfRslaIhqMCL5XAlnr3XI=",
          "cpf": "U2FsdGVkX19o7Pd6MBUclVD4aYz5SdpckRgInwSjG5M="
        }, {
          "num_cand": "U2FsdGVkX1/lGq0xI/LIN5V7UU4C0yC0hme9Tde5oHk=",
          "cpf": "U2FsdGVkX18VgaO//t8QXBgPO4CfSj1udWwKPZ1Yq7s="
        }, {
          "num_cand": "U2FsdGVkX19UGfA0rRnFf6szQtSoAcTkY4J1pjjY7cI=",
          "cpf": "U2FsdGVkX18cIjrcBuT1anflbzvTstEPnFgV7vC0hUQ="
        }, {
          "num_cand": "U2FsdGVkX18ZRc474IOUyd5c71Ft4Z8XQLgIGRHXMbU=",
          "cpf": "U2FsdGVkX1+C44Ucsr9w9g5AnBOqy1OpyPWeOw8TV94="
        }, {
          "num_cand": "U2FsdGVkX1+zrjK++MwcxyGNMncUkNV08hVF1P6OTFI=",
          "cpf": "U2FsdGVkX18dahrv2QMmF5aw2D0+aZ2xLpkp4rYzp+U="
        }, {
          "num_cand": "U2FsdGVkX1//eMs8Ab4Aqbk9EzKNX2wJLy1B7cyme90=",
          "cpf": "U2FsdGVkX1/T1KWqVoTg5kJbXKI9Zb+fbaxFNJeAMA4="
        }, {
          "num_cand": "U2FsdGVkX19B+tWWCvuN0YpC1Awh/6rR16tzI59p1QE=",
          "cpf": "U2FsdGVkX199xj6CX6znoEy17oMSbLH2bXdRGys656c="
        }, {
          "num_cand": "U2FsdGVkX1/LzH1GUcd5+r7UfldnNgSapKeh60cn3hg=",
          "cpf": "U2FsdGVkX19/5yW8dEqJEav9ICM2LcXNiYyu6GP2gE8="
        }, {
          "num_cand": "U2FsdGVkX1+puyp1PIXbty4CphBAcsWraK5zrjo1OQs=",
          "cpf": "U2FsdGVkX1/q5wyEthVmTDparam7fmnigQFupwBzSmQ="
        }, {
          "num_cand": "U2FsdGVkX18ABq6mu2iug9uzLPJ4f18jA0FkPjL9/Gg=",
          "cpf": "U2FsdGVkX192Fbd4mD0NQetFsSjO4AeUSiYbdfhl3r8="
        }, {
          "num_cand": "U2FsdGVkX1+WaCv0Q20kiRUQ98/72GOYAFxH+HiGeK0=",
          "cpf": "U2FsdGVkX183PNSisgaCdy33a+EH9UNqcMMhS9vg5hA="
        }, {
          "num_cand": "U2FsdGVkX185PMZL77tbSkepJt6ohxX7DlQeOhSAQ54=",
          "cpf": "U2FsdGVkX189OdMMuaqIFoVY3s/VkOonywsZAtTmCec="
        }, {
          "num_cand": "U2FsdGVkX1+MaT9rIfVo21tp6F8YebIffufn1GpQeks=",
          "cpf": "U2FsdGVkX19rlMvgAj2qw2xpZNYbh48KapXwan/MW+A="
        }, {
          "num_cand": "U2FsdGVkX1/lgjiOXbCXy+Q10n6KOMNLITPMWufx6uw=",
          "cpf": "U2FsdGVkX1+FvLlpBJQdlKRemfcd8Z0F8Mw1cvt6G+g="
        }, {
          "num_cand": "U2FsdGVkX1/5gOGHjsW5Gs52fxkllytcmsw9KlUnTC0=",
          "cpf": "U2FsdGVkX1/Wjy9ndibjr52mt2+nOJVRUuH9CpQLqHU="
        }, {
          "num_cand": "U2FsdGVkX1/WX9k9DD1LcpS3JbPOCDUWseP/3SFkwTQ=",
          "cpf": "U2FsdGVkX1+FtDb2mT2nXf7H0sfs0cNbYmytKpt+Gz0="
        }, {
          "num_cand": "U2FsdGVkX1+rkReSmr9hdxf/rN9AWkd3Hcj53Q5ro9A=",
          "cpf": "U2FsdGVkX195DGiZ6lrkkJSiWHPeYUprH6la2uD/ekc="
        }, {
          "num_cand": "U2FsdGVkX1+QTQh8Z36zbSOYYJYCfTMk9fk7bpvzrP0=",
          "cpf": "U2FsdGVkX1/SuUC+vsWS40FrnmeK4secdsYChH+MDmw="
        }, {
          "num_cand": "U2FsdGVkX1/USwunpZagU78SswSkCqSBOpyxfkn88z0=",
          "cpf": "U2FsdGVkX184AHsLe9tzkny9XFyf4L4rEIstAfXZ5u4="
        }, {
          "num_cand": "U2FsdGVkX19tYBSFoswO/68KK7WidO1pclVttuVQIQo=",
          "cpf": "U2FsdGVkX1+w//p6zfL10ABvOt2KbN9QO4ieCdiU9Pw="
        }, {
          "num_cand": "U2FsdGVkX19939HwRS/5ORn4ebOD46xf/L3jTMHlzJA=",
          "cpf": "U2FsdGVkX19i12nerYTaa6bVYYp3M2hDhUuhJnBfNhs="
        }, {
          "num_cand": "U2FsdGVkX1+NQ8XAU1cYlpkMbsOFFSB37LZ4ah2EEY4=",
          "cpf": "U2FsdGVkX1/iBMHmL/x3Y3CBPZy9KixuLhk7kihw/6M="
        }, {
          "num_cand": "U2FsdGVkX1/oYluHRM1uArZraKlNnCCTCSuKhJOCIGE=",
          "cpf": "U2FsdGVkX1/vTCZEUC3T2P8sJkK1E9PXzaToKwuek1s="
        }, {
          "num_cand": "U2FsdGVkX1/Oxevq5lCLQB5kxetwkgYnDlqE5ejfdUk=",
          "cpf": "U2FsdGVkX19LTLmylnVqevsKJsFaGGHY8MY1yVQC6O4="
        }, {
          "num_cand": "U2FsdGVkX1/nRYtyqr3NrkOzwWt+VqDXoqSdbRAT4MI=",
          "cpf": "U2FsdGVkX19w6/MDZEEMQ6rCj/2JV7pyLGSNZXXuXG8="
        }, {
          "num_cand": "U2FsdGVkX18oud9sssgICS2ve98aOx5NPj/82FQpinE=",
          "cpf": "U2FsdGVkX18+aXSucCQ7sBZEJ5GNyCLlkV1bPE9EFOM="
        }, {
          "num_cand": "U2FsdGVkX1+Nn7xMAYUiJ8diklkDeBNkvBI0+NTshe0=",
          "cpf": "U2FsdGVkX1+PwYERXNHEqw0GrWqD793QvRHVyfbItnQ="
        }, {
          "num_cand": "U2FsdGVkX1+0h2RxAPbwFJcpbsAZ90pzpGqHoPCsayY=",
          "cpf": "U2FsdGVkX1/1BLtvIx3KSqHkmiaov3lC9klReXYw4cg="
        }, {
          "num_cand": "U2FsdGVkX1+eF4XPbl3anvDeJcx4lC2ArgtT+WiHEz0=",
          "cpf": "U2FsdGVkX1+DSiSsnP17cc8SfWRluvSRpd7iBwMGJBQ="
        }, {
          "num_cand": "U2FsdGVkX185Nulv5Vi/yLZdpCazRIcZ4bMtq0QqnYE=",
          "cpf": "U2FsdGVkX19AsDSuOYQYhCMSPSxxXHP5NdhUz30PbfM="
        }, {
          "num_cand": "U2FsdGVkX1+PrG4dVD1kAurSJ0KxJu+fPTb38Dfal8U=",
          "cpf": "U2FsdGVkX18WZEfiSiMfEUknmMiqal3D+Wbbo8qniaY="
        }, {
          "num_cand": "U2FsdGVkX1/Ip6oDh3RCRgd6dVSYq9i4IQvnT3U7jfw=",
          "cpf": "U2FsdGVkX193ZE2w3xhXLABxr8bRCkXGJHnHx4t5WOk="
        }, {
          "num_cand": "U2FsdGVkX1+JtOBlFzynRJw7Xd3Hzo0nPeX2i8K6aXk=",
          "cpf": "U2FsdGVkX19XIvjQmcPV6he4iJoegID2Uo3Oc+N4ndo="
        }, {
          "num_cand": "U2FsdGVkX18HEq7hxgSZ7HqoDVNuL70nqbe+Vl5myD4=",
          "cpf": "U2FsdGVkX1+P/Z+g4//0iA+TgYohkrN5nFWbqRHL7Vs="
        }, {
          "num_cand": "U2FsdGVkX1/bvowM+TtNdZYuoQFQpoYcYmbsgPJASAE=",
          "cpf": "U2FsdGVkX19v+oLDsFa03iqx3zX4W/Zk4MK4HT+aJ6s="
        }, {
          "num_cand": "U2FsdGVkX19kwkut6RLssk7WEvANYyxxQaTcUKfXNMo=",
          "cpf": "U2FsdGVkX1/28NiVmW8TGyh6oyjWnsaiAJKGWQJMraU="
        }, {
          "num_cand": "U2FsdGVkX19V4hoPplb5JhQFqJydScTuNq5h0jN13FQ=",
          "cpf": "U2FsdGVkX1/drnIdVvYHK+k5pNk2cj2FzXTa03pySZ4="
        }, {
          "num_cand": "U2FsdGVkX1+j1vBfN0POORTQISvroogChY1Y8rQ/CyA=",
          "cpf": "U2FsdGVkX1/CKtliJtv7M0IsSTcnbUAkdKyf2jdoPcE="
        }, {
          "num_cand": "U2FsdGVkX1/JIY/EwoELGJtwUi5Yy0ARuMMiyCemXjY=",
          "cpf": "U2FsdGVkX1/Cj5ntGWrTWzV8TqcY6geQhVSrhewc7RY="
        }, {
          "num_cand": "U2FsdGVkX18TX9LcUMI2s8Q1i6yQMLR2qV0rMAbRsho=",
          "cpf": "U2FsdGVkX18Y2qSvenQjhZ1eNxKt9fdX7AIlmc+yHNk="
        }, {
          "num_cand": "U2FsdGVkX1+4nSfdzOT5CBmwAQIBOoecj6VPIClVqGE=",
          "cpf": "U2FsdGVkX1/Su53Z9BDu2JoxSLrUyuDsAJCdBMtfxFE="
        }, {
          "num_cand": "U2FsdGVkX1+XHQMSe5RJNhBcMusf5xY570Sb1lPeNGM=",
          "cpf": "U2FsdGVkX18so5V+mN6zQUIFvYFX6iWPuGreKm+9V8g="
        }, {
          "num_cand": "U2FsdGVkX18ZesWrCzR/4kWq/gXmpC2frbw86xEq8i0=",
          "cpf": "U2FsdGVkX18vc8htjCS0Xtoq8VG+o281t8gDAWCrltY="
        }, {
          "num_cand": "U2FsdGVkX18g8rkBwTyB9fGWsUCmtfZqNs1oTK5ZriA=",
          "cpf": "U2FsdGVkX1/BKN3KQ9GQRsIZ5BrUwpX/zF9LIjspUp4="
        }, {
          "num_cand": "U2FsdGVkX1+sbgKAP2JMqC88ZcFt8gcJ4ORlWZJ3xY0=",
          "cpf": "U2FsdGVkX1+QlM6bLNkd13mRXwel2n1mYJu+aH0BeAY="
        }, {
          "num_cand": "U2FsdGVkX1/+s41dyUJNnk1VlW+twB2DKJvI+ZeOV8w=",
          "cpf": "U2FsdGVkX18L7Hlq2UB4/97rDRxL3RiPKgpmnN0//2U="
        }, {
          "num_cand": "U2FsdGVkX1884p6/IwA8MgjFq8i9EeCyQRIzKp9HrGA=",
          "cpf": "U2FsdGVkX18Bk4vnAnfRfV1jWyI5flkKPxNXMFDU80Q="
        }, {
          "num_cand": "U2FsdGVkX1/jAsvt2xUpi7TaECLBNatMQUagsLPFNNk=",
          "cpf": "U2FsdGVkX1+F0jvpCpSNMjFlsoyFDCwt4B+oqZ7KWCk="
        }, {
          "num_cand": "U2FsdGVkX1/FAesEltAtpPcNCiffBgWmVEZ5HJW6Vmk=",
          "cpf": "U2FsdGVkX1/LLcDPURBMDNGBxIpQ1eY1Kzg1wJRWqos="
        }, {
          "num_cand": "U2FsdGVkX1+nOb3B5hpammE6YaczRX9yFn7ojVrFc00=",
          "cpf": "U2FsdGVkX1+LRlsXYuQrmMJwPtFeKz6PQpSrwi0SF38="
        }, {
          "num_cand": "U2FsdGVkX195XVgSn3cox9tB5wBd6cQmlKcZonhJmHg=",
          "cpf": "U2FsdGVkX1+TZcWz/x2vtT5+jkzi3yuWRoTZ9HIWNJ8="
        }, {
          "num_cand": "U2FsdGVkX19XJHIR3VT0HgSD/Vd3cSLmRWgiZf46cKg=",
          "cpf": "U2FsdGVkX19XRXJ7m6NmZB8OipPIMB32550IOnp+ddo="
        }, {
          "num_cand": "U2FsdGVkX1/7K9BUF/oiav/pi5ldbFSCVgTHv38KlHg=",
          "cpf": "U2FsdGVkX1/nHfVPj51EIgWSceAojMxaGHjHDizI+Uw="
        }, {
          "num_cand": "U2FsdGVkX19aLx2DMOkXq2rL3hIG40qEjWYjeTiMRtA=",
          "cpf": "U2FsdGVkX19QB6YSeGW13EgaoXY4k/1zxDfUJosqBI4="
        }, {
          "num_cand": "U2FsdGVkX1/g+2m9aXjfv1Mlhjg0a5o4lvPJrjPUxdc=",
          "cpf": "U2FsdGVkX19TOqyXOlM7DxhBInOzo/vGFzyM7cbprew="
        }, {
          "num_cand": "U2FsdGVkX1+YtBHDQlnSrNFNs/XW53Ihy3NsOmgB/bA=",
          "cpf": "U2FsdGVkX1/aZrX5P9qb1wlZ+RJ0j7hy3xulqqsIQIo="
        }, {
          "num_cand": "U2FsdGVkX18hQLfuEP76qC4Bw5h6XKtE+vmEQstA/xA=",
          "cpf": "U2FsdGVkX1/BkOqAkDZ1V0sXGmUYDh+nSoNA2uijccI="
        }, {
          "num_cand": "U2FsdGVkX190n3stz7AA1UvRXfFHHIHUHHPtcLohnoQ=",
          "cpf": "U2FsdGVkX1/s6VenLA6WDUW6XzgvISlRKufL36D+fRQ="
        }, {
          "num_cand": "U2FsdGVkX1/7pbKF0KUDqksvaZR2BHLHYepdZwkjQv4=",
          "cpf": "U2FsdGVkX1/ffv/pnxBIb7o/YbUwFQjliz/gvIjpkvI="
        }, {
          "num_cand": "U2FsdGVkX18pbuofMS257vnEl3EjSs5m50be0M3oHbo=",
          "cpf": "U2FsdGVkX1/DkH5BxJTJxiSF/ZJm4KpDUu1Ag362lK8="
        }, {
          "num_cand": "U2FsdGVkX1/+0erKzn4qIz0jJZMO2deni0ueIF0nxG0=",
          "cpf": "U2FsdGVkX19HOl9iUWAFXvXE4ItnSboe9XRHIp+McnY="
        }, {
          "num_cand": "U2FsdGVkX18jMbVu9cx7gB4qqFeSQHzM7umWM0xqv8g=",
          "cpf": "U2FsdGVkX1+epioLOcyUrTasBRgGZfU4HHwOH9UUVfI="
        }, {
          "num_cand": "U2FsdGVkX18W8LVvVeA8OqfBzrPQgxfow135yt0RZYg=",
          "cpf": "U2FsdGVkX199Wsb7qXxZmolkQ6HxL5jaRLxLYdzFNg8="
        }, {
          "num_cand": "U2FsdGVkX18vMVceCJOcxYztjorrQJ0+UiqHoCM4bAM=",
          "cpf": "U2FsdGVkX19dFi8m8e8NnsfgBpGa77EclHI1m56S71I="
        }, {
          "num_cand": "U2FsdGVkX19PE4HpY3DL4dDWWmBfWPQPqgFH74arWaE=",
          "cpf": "U2FsdGVkX19Xl3El1uNvOys4ACeeQUPbwguZHYmZsyE="
        }, {
          "num_cand": "U2FsdGVkX1/WgRrucT9Oma5U6MLRf6Oo8+WxHiB/O6w=",
          "cpf": "U2FsdGVkX18D0rmCx0v+fOUiU6UbmWvu9XiP+WFQ07Q="
        }, {
          "num_cand": "U2FsdGVkX1/V/5Z1MM8UMDk3JJJgbk8Nbj/Zt19xcGc=",
          "cpf": "U2FsdGVkX19tOHra0uE9Tk4gsYDs77WMW5dZ6IRNV3I="
        }, {
          "num_cand": "U2FsdGVkX1/I8HXkCmNGd+ZE5xnAPH7QZm31DQMXb3E=",
          "cpf": "U2FsdGVkX1/ewER/5nFHWfWOUoBXbd7Xov7t0RqZCZ4="
        }, {
          "num_cand": "U2FsdGVkX19+GSur3R0GMCnOL4FHnCqhQaP5M755FY8=",
          "cpf": "U2FsdGVkX19NQRVLcGfJAQ/uE21DjLVE/jdBuareEMM="
        }, {
          "num_cand": "U2FsdGVkX1/117yMqa9sBrcO+7aNrUfAfkA/1I8xIaM=",
          "cpf": "U2FsdGVkX1/yFXKiVG4ElsYXiXZ0Ifx8hup0akIoO5w="
        }, {
          "num_cand": "U2FsdGVkX19/P6GJUzzExhRfWL78Vu6EZAGESgob+lU=",
          "cpf": "U2FsdGVkX1+c59Eoi86VAnuMSV+CkC8+GKC4RQmKCg4="
        }, {
          "num_cand": "U2FsdGVkX1/QnEoLj3W4dPqGaDnC4+pfKOPw5rS72MM=",
          "cpf": "U2FsdGVkX1+QfcCLCRGlrNionl46z79v6LKsBkRLBCc="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2211/211_result_impu/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
